import {
    get,
    hasIn,
} from 'lodash';
import { 
    mergeEditModeFormData,
    prepareSchemaPageForEditing,
    addPage,
    isPageTitleValid,
    generate_map,
} from '../../utils';

export const ACTIONS = {
    SELECT_STUDENT: 'SELECT_STUDENT',
    SET_STUDENT_RESPONSE: 'SET_STUDENT_RESPONSE',
    REQUEST_DELETE_RESPONSE: 'REQUEST_DELETE_RESPONSE',
    DELETE_RESPONSE_SUCCESS: 'DELETE_RESPONSE_SUCCESS',
    DELETE_RESPONSE_FAIL: 'DELETE_RESPONSE_FAIL',
    SET_ADMIN_LIST: 'SET_ADMIN_LIST',
    REQUEST_SET_ADMIN_PERMISSIONS: 'REQUEST_SET_ADMIN_PERMISSIONS',
    SET_ADMIN_PERMISSIONS_SUCCESS: 'SET_ADMIN_PERMISSIONS_SUCCESS',
    SET_ADMIN_PERMISSIONS_FAIL: 'SET_ADMIN_PERMISSIONS_FAIL',
    REQUEST_DELETE_ADMIN: 'REQUEST_DELETE_ADMIN',
    DELETE_ADMIN_SUCCESS: 'DELETE_ADMIN_SUCCESS',
    DELETE_ADMIN_FAIL: 'DELETE_ADMIN_FAIL',
    REQUEST_SET_RESPONSE_ADMIN: 'REQUEST_SET_RESPONSE_ADMIN',
    SET_RESPONSE_ADMIN_SUCCESS: 'SET_RESPONSE_ADMIN_SUCCESS',
    SET_RESPONSE_ADMIN_FAIL: 'SET_RESPONSE_ADMIN_FAIL',
    SET_LOADING: 'SET_LOADING',
    REQUEST_NEEDS_REVIEW_LIST: 'REQUEST_NEEDS_REVIEW_LIST',
    NEEDS_REVIEW_LIST_SUCCESS: 'NEEDS_REVIEW_LIST_SUCCESS',
    NEEDS_REVIEW_LIST_FAIL: 'NEEDS_REVIEW_LIST_FAIL',
    SET_EDIT_SCHEMA: 'SET_EDIT_SCHEMA',
    SET_EDIT_FORM_DATA: 'SET_EDIT_FORM_DATA',
    START_EDIT_SCHEMA: 'START_EDIT_SCHEMA',
    CANCEL_EDIT_SCHEMA: 'CANCEL_EDIT_SCHEMA',
    SET_PAGE_SCHEMA: 'SET_PAGE_SCHEMA',
    PREVIEW_EDIT_SCHEMA: 'PREVIEW_EDIT_SCHEMA',
    REQUEST_SCHEMA_LIST: 'REQUEST_SCHEMA_LIST',
    SCHEMA_LIST_SUCCESS: 'SCHEMA_LIST_SUCCESS',
    SCHEMA_LIST_FAIL: 'SCHEMA_LIST_FAIL',
    REQUEST_CLIENT_LIST: 'REQUEST_CLIENT_LIST',
    CLIENT_LIST_SUCCESS: 'CLIENT_LIST_SUCCESS',
    CLIENT_LIST_FAIL: 'CLIENT_LIST_FAIL',
    REQUEST_DELETE_CLIENT: 'REQUEST_DELETE_CLIENT',
    DELETE_CLIENT_SUCCESS: 'DELETE_CLIENT_SUCCESS',
    DELETE_CLIENT_FAIL: 'DELETE_CLIENT_FAIL',
    REQUEST_UPDATE_SCHEMA: 'REQUEST_UPDATE_SCHEMA',
    SCHEMA_UPDATE_FAIL: 'SCHEMA_UPDATE_FAIL',
    SCHEMA_UPDATE_SUCCESS: 'SCHEMA_UPDATE_SUCCESS',
    REQUEST_CREATE_SCHEMA: 'REQUEST_CREATE_SCHEMA',
    CREATE_SCHEMA_SUCCESS: 'CREATE_SCHEMA_SUCCESS',
    CREATE_SCHEMA_FAIL: 'CREATE_SCHEMA_FAIL',
    SET_ADD_PAGE_TITLE: 'SET_ADD_PAGE_TITLE',
    ADD_PAGE_TO_EDIT_SCHEMA: 'ADD_PAGE_TO_EDIT_SCHEMA',
    SET_SHOW_ADD_PAGE_PROPERTY: 'SET_SHOW_ADD_PAGE_PROPERTY',
    SET_ADD_PAGE_PROPERTY_FORM_DATA: 'SET_ADD_PAGE_PROPERTY_FORM_DATA',
    ADD_PAGE_PROPERTY: 'ADD_PAGE_PROPERTY',
};

export function setLoading(loading) {
    return {
        type: ACTIONS.SET_LOADING,
        payload: loading
    }
}

export function setAddPageTitle(title) {
    return {
        type: ACTIONS.SET_ADD_PAGE_TITLE,
        payload: title,
    }
}

export function setShowAddPageProperty(show=false) {
    return {
        type: ACTIONS.SET_SHOW_ADD_PAGE_PROPERTY,
        payload: show,
    }
}

export function setAddPagePropertyFormData(form_data) {
    return {
        type: ACTIONS.SET_ADD_PAGE_PROPERTY_FORM_DATA,
        payload: form_data,
    }
}

export function addPageProperty() {
    return {
        type: ACTIONS.ADD_PAGE_PROPERTY,
        payload: undefined,
    }
}

export function addPageToEditSchema(title) {
    return {
        type: ACTIONS.ADD_PAGE_TO_EDIT_SCHEMA,
        payload: title,
    }
}

export function requestSetResponseAdmin(student) {
    return {
        type: ACTIONS.REQUEST_SET_RESPONSE_ADMIN,
        payload: student,
    };
}

export function setResponseAdminSuccess(student) {
    return {
        type: ACTIONS.SET_RESPONSE_ADMIN_SUCCESS,
        payload: student,
    };
}

export function setResponseAdminFail() {
    return {
        type: ACTIONS.SET_RESPONSE_ADMIN_FAIL,
        payload: undefined,
    };
}

export function requestSetAdminPermissions(admin) {
    return {
        type: ACTIONS.REQUEST_SET_ADMIN_PERMISSIONS,
        payload: admin
    };
}

export function setAdminPermissionsSuccess(admin) {
    return {
        type: ACTIONS.SET_ADMIN_PERMISSIONS_SUCCESS,
        payload: admin,
    };
}

export function setAdminPermissionsFail() {
    return {
        type: ACTIONS.SET_ADMIN_PERMISSIONS_FAIL,
        payload: undefined,
    };
}

export function requestDeleteAdmin(admin) {
    return {
        type: ACTIONS.REQUEST_DELETE_ADMIN,
        payload: admin
    };
}

export function deleteAdminSuccess(admin) {
    return {
        type: ACTIONS.DELETE_ADMIN_SUCCESS,
        payload: admin,
    };
}

export function deleteAdminFail() {
    return {
        type: ACTIONS.DELETE_ADMIN_FAIL,
        payload: undefined,
    };
}

export function setAdminList(admin_list) {
    return {
        type: ACTIONS.SET_ADMIN_LIST,
        payload: admin_list,
    };
}

export function requestNeedsReviewList() {
    return {
        type: ACTIONS.REQUEST_NEEDS_REVIEW_LIST,
    };
}

export function needsReviewListSuccess(needs_review_list) {
    return {
        type: ACTIONS.NEEDS_REVIEW_LIST_SUCCESS,
        payload: needs_review_list,
    };
}

export function needsReviewListFail() {
    return {
        type: ACTIONS.NEEDS_REVIEW_LIST_FAIL,
    };
}

export function requestSchemaList() {
    return {
        type: ACTIONS.REQUEST_SCHEMA_LIST,
    };
}

export function schemaListSuccess(schema_list) {
    return {
        type: ACTIONS.SCHEMA_LIST_SUCCESS,
        payload: schema_list,
    };
}

export function schemaListFail() {
    return {
        type: ACTIONS.SCHEMA_LIST_FAIL,
    };
}

export function requestClientList() {
    return {
        type: ACTIONS.REQUEST_CLIENT_LIST,
    };
}

export function clientListSuccess(client_list) {
    return {
        type: ACTIONS.CLIENT_LIST_SUCCESS,
        payload: client_list,
    };
}

export function clientListFail() {
    return {
        type: ACTIONS.CLIENT_LIST_FAIL,
    };
}

export function requestDeleteClient(client_id) {
    return {
        type: ACTIONS.REQUEST_DELETE_CLIENT,
        payload: client_id,
    };
}

export function deleteClientSuccess() {
    return {
        type: ACTIONS.DELETE_CLIENT_SUCCESS,
    };
}

export function deleteClientFail(client_id) {
    return {
        type: ACTIONS.DELETE_CLIENT_FAIL,
        payload: client_id,
    };
}

export function requestUpdateSchema(json_obj) {
    return {
        type: ACTIONS.REQUEST_UPDATE_SCHEMA,
        payload: json_obj,
    };
}

export function schemaUpdateFail() {
    return {
        type: ACTIONS.SCHEMA_UPDATE_FAIL,
    };
}

export function schemaUpdateSuccess() {
    return {
        type: ACTIONS.SCHEMA_UPDATE_SUCCESS,
    };
}

export function requestCreateSchema(body) {
    return {
        type: ACTIONS.REQUEST_CREATE_SCHEMA,
        payload: body,
    };
}

export function schemaCreateSuccess(id) {
    return {
        type: ACTIONS.CREATE_SCHEMA_SUCCESS,
        payload: id,
    }
}

export function schemaCreateFail() {
    return {
        type: ACTIONS.CREATE_SCHEMA_FAIL,
    };
}

export function selectStudent(student) {
    return {
        type: ACTIONS.SELECT_STUDENT,
        payload: student,
    };
}

export function setStudentResponse(response) {
    return {
        type: ACTIONS.SET_STUDENT_RESPONSE,
        payload: response,
    };
}

export function requestDeleteResponse(response) {
    return {
        type: ACTIONS.REQUEST_DELETE_RESPONSE,
        payload: response,
    };
}

export function deleteResponseSuccess() {
    return {
        type: ACTIONS.DELETE_RESPONSE_SUCCESS,
        payload: undefined,
    };
}

export function deleteResponseFail() {
    return {
        type: ACTIONS.DELETE_RESPONSE_FAIL,
        payload: undefined,
    };
}


export function setEditSchema(schema) {
    return {
        type: ACTIONS.SET_EDIT_SCHEMA,
        payload: schema,
    };
}

/**
 * 
 * @param { any } form_data 
 */
export function setEditFormData(form_data) {
    return {
        type: ACTIONS.SET_EDIT_FORM_DATA,
        payload: form_data,
    };
}

/**
 * 
 * @param { {form_data: any} } options 
 */
export function startEditSchema(options) {
    return {
        type: ACTIONS.START_EDIT_SCHEMA,
        payload: options,
    };
}

/**
 * 
 */
export function cancelEditSchema() {
    return {
        type: ACTIONS.CANCEL_EDIT_SCHEMA,
    };
}

/**
 * Set the page schema to be edited and remember which properties were
 * `path` types for eventual merging back into main schema
 * @param { {page_schema: any, path_types: any} } options 
 */
export function setPageSchema(options) {
    return {
        type: ACTIONS.SET_PAGE_SCHEMA,
        payload: options,
    };
}

export function previewEditSchema() {
    return {
        type: ACTIONS.PREVIEW_EDIT_SCHEMA,
    };
}

/**
 * @typedef EditSchema
 * @type {object}
 * @property {object} schema schema to update
 * @property {object} form_data form data for page being updated
 * @property {object} page_schema schema for page being updated
 * @property {boolean} edit_mode is editing page
 * @property {boolean} has_edited schema has been edited an can be updated
 * @property {boolean} has_saved schema has been saved/updated
 * @property {object} edit_mode_page_schema page schema for page being updated
 * @property {object} path_types storage for path types on a page being edited
 * @property {boolean} page_title_valid is new page title valid
 * @property {boolean} show_add_page_property show modal for adding new property to page
 * @property {object} add_page_property_form_data form data for adding new property to page
 */

/**
 * @typedef AdminState
 * @type {object}
 * @property {string} selected_student_id id of selected student
 * @property { {mapped_response: object, original_response: object} } student_last_response last response from student with the original version and a mapped version for display purposes
 * @property {boolean} deleting_response in the process of deleting response
 * @property {boolean} delete_response_error error deleting response
 * @property {object[]} admin_list list of admins
 * @property {object[]} needs_review_list list of responses that need review
 * @property {object[]} schema_list list of schemas
 * @property {object[]} client_list list of clients
 * @property {string|null} admin_error
 * @property {boolean} updating_schema in the process of updating schema
 * @property {EditSchema} edit_schema
 */

export const DEFAULT_STATE = {
    selected_student_id: undefined,
    student_last_response: undefined,
    deleting_response: false,
    delete_response_error: false,
    admin_list: [],
    needs_review_list: [],
    schema_list: [],
    client_list: [],
    admin_error: null,
    loading: false,
    updating_schema: false,
    // ALC - it might be worth it to split the edit section into its own reducer eventually
    edit_schema: {
        schema: undefined,
        form_data: undefined,
        page_schema: undefined,
        edit_mode: false,
        has_edited: false,
        has_saved: true,
        edit_mode_page_schema: undefined,
        add_page_title: '',
        page_title_valid: true,
        show_add_page_property: false,
        add_page_property_form_data: {},
    }
};

export function adminReducer(state=DEFAULT_STATE, action) {
    switch(action.type) {
        case ACTIONS.SET_LOADING: {
            const loading = get(action, 'payload');
            return {
                ...state,
                loading,
            };
        }
        case ACTIONS.SELECT_STUDENT: {
            const selected_student_id = get(action, 'payload');
            return {
                ...state,
                selected_student_id,
            };
        }
        case ACTIONS.SET_STUDENT_RESPONSE: {
            return {
                ...state,
                student_last_response: action.payload,
                loading: false,
            };
        }
        case ACTIONS.REQUEST_DELETE_RESPONSE: {
            return {
                ...state,
                deleting_response: true,
                delete_response_error: false,
            }
        }
        case ACTIONS.DELETE_RESPONSE_SUCCESS: {
            return {
                ...state,
                deleting_response: false,
                delete_response_error: false,
                student_last_response: undefined,
            }
        }
        case ACTIONS.DELETE_RESPONSE_FAIL: {
            return {
                ...state,
                deleting_response: false,
                delete_response_error: true,
            }
        }
        case ACTIONS.SET_ADMIN_LIST: {
            return {
                ...state,
                admin_list: action.payload,
            };
        }
        case ACTIONS.REQUEST_SET_ADMIN_PERMISSIONS: {
            return state;
        }
        case ACTIONS.SET_ADMIN_PERMISSIONS_FAIL: {
            // maybe set an alert instead?
            return state;
        }
        case ACTIONS.SET_ADMIN_PERMISSIONS_SUCCESS: {
            return {
                ...state,
                admin_list: state.admin_list.map((admin) => {
                    return (admin.id === action.payload.id) ? action.payload : admin;
                })
            };
        }
        case ACTIONS.REQUEST_DELETE_ADMIN: {
            return state;
        }
        case ACTIONS.DELETE_ADMIN_FAIL: {
            // maybe set an alert instead?
            return state;
        }
        case ACTIONS.DELETE_ADMIN_SUCCESS: {
            return {
                ...state,
                admin_list: state.admin_list.filter((admin) => {
                    return (admin.id !== action.payload.id);
                })
            }
        }
        case ACTIONS.REQUEST_SET_RESPONSE_ADMIN: {
            return {
                ...state,
                student_last_response: {
                    ...state.student_last_response,
                    original_response: action.payload,
                }
            };
        }
        case ACTIONS.REQUEST_NEEDS_REVIEW_LIST: {
            return {
                ...state,
                loading: true,
            }
        }
        case ACTIONS.NEEDS_REVIEW_LIST_SUCCESS: {
            return {
                ...state,
                needs_review_list: action.payload,
                loading: false,
            };
        }
        case ACTIONS.NEEDS_REVIEW_LIST_FAIL: {
            return {
                ...state,
                loading: false,
            };
        }
        case ACTIONS.SET_EDIT_SCHEMA: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    schema: action.payload,
                    page_schema: undefined,
                }
            };
        }
        case ACTIONS.SET_EDIT_FORM_DATA: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    form_data: action.payload,
                    has_edited: true,
                }
            };
        }
        case ACTIONS.START_EDIT_SCHEMA: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    ...action.payload,
                    edit_mode: true,
                }
            };
        }
        case ACTIONS.CANCEL_EDIT_SCHEMA: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    edit_mode: false,
                    has_edited: false,
                    edit_mode_page_schema: undefined,
                }
            };
        }
        case ACTIONS.SET_PAGE_SCHEMA: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    ...action.payload,
                }
            };
        }
        case ACTIONS.PREVIEW_EDIT_SCHEMA: {
            const schema = mergeEditModeFormData(state.edit_schema);
            const [
                page_schema,
                path_types,
            ] = prepareSchemaPageForEditing(schema, state.edit_schema.page_schema.id);
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    page_schema,
                    path_types,
                    schema,
                    form_data: undefined,
                    edit_mode: false,
                    has_edited: false,
                    has_saved: false,
                    edit_mode_page_schema: undefined,
                }
            }
        }
        case ACTIONS.REQUEST_SCHEMA_LIST: {
            return {
                ...state,
                loading: true,
            };
        }
        case ACTIONS.SCHEMA_LIST_SUCCESS: {
            return {
                ...state,
                schema_list: action.payload,
                loading: false,
            };
        }
        case ACTIONS.SCHEMA_LIST_FAIL: {
            return {
                ...state,
                loading: false,
                admin_error: 'Failed to get schema list from server!',
            };
        }
        case ACTIONS.REQUEST_CLIENT_LIST: {
            return {
                ...state,
                loading: true,
            };
        }
        case ACTIONS.CLIENT_LIST_SUCCESS: {
            return {
                ...state,
                client_list: action.payload,
                loading: false,
            };
        }
        case ACTIONS.CLIENT_LIST_FAIL: {
            return {
                ...state,
                loading: false,
                admin_error: 'Failed to get client list from server!',
            };
        }
        case ACTIONS.REQUEST_DELETE_CLIENT: {
            return {
                ...state,
                loading: true,
            };
        }
        case ACTIONS.DELETE_CLIENT_SUCCESS: {
            return {
                ...state,
                loading: false,
            };
        }
        case ACTIONS.DELETE_CLIENT_FAIL: {
            return {
                ...state,
                loading: false,
                admin_error: `Failed to delete client id: ${action.payload}!`,
            };
        }
        case ACTIONS.REQUEST_UPDATE_SCHEMA: {
            const changed_id = get(action, ['payload', 'id']);
            const default_changed = hasIn(action.payload, 'variant');
            const updated_at = new Date();
            const new_schema_list = state.schema_list.map((schema_obj) => {
                if (schema_obj.id === changed_id) {
                    return {
                        ...schema_obj,
                        ...action.payload,
                        updated_at,
                    };
                } else if (default_changed && schema_obj.variant === 'default') {
                    return {
                        ...schema_obj,
                        variant: '',
                        updated_at,
                    };
                }
                return schema_obj;
            });
            return {
                ...state,
                updating_schema: true,
                schema_list: new_schema_list,
                admin_error: undefined,
            };
        }
        case ACTIONS.SCHEMA_UPDATE_FAIL: {
            return {
                ...state,
                updating_schema: false,
                admin_error: 'Failed to update schema on server!',
            };
        }
        case ACTIONS.SCHEMA_UPDATE_SUCCESS: {
            return {
                ...state,
                updating_schema: false,
                edit_schema: {
                    ...state.edit_schema,
                    has_saved: true,
                }
            };
        }
        case ACTIONS.REQUEST_CREATE_SCHEMA: {
            const time_now = new Date();
            const last_id = state.schema_list[state.schema_list.length-1].id;
            return {
                ...state,
                schema_list: [ ...state.schema_list, {
                    id: last_id+1,
                    variant:'',
                    updated_at: time_now,
                    created_at: time_now,
                }],
            };
        }
        case ACTIONS.SET_ADD_PAGE_TITLE: {
            const page_title_valid = isPageTitleValid(state.edit_schema.schema, action.payload);
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    add_page_title: action.payload,
                    page_title_valid,
                }
            };
        }
        case ACTIONS.ADD_PAGE_TO_EDIT_SCHEMA: {
            const schema = addPage({
                title: action.payload,
            }, state.edit_schema.schema);
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    schema,
                    has_edited: true,
                    has_saved: false,
                }
            };
        }
        case ACTIONS.SET_SHOW_ADD_PAGE_PROPERTY: {
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    show_add_page_property: action.payload,
                    add_page_property_form_data: {},
                }
            }
        }
        case ACTIONS.SET_ADD_PAGE_PROPERTY_FORM_DATA: {
            // merge the payload and the current `form_data` because the `form_data`
            // will be sent one property at a time like `{ title: 'Property Title' }`
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    add_page_property_form_data: {
                        ...state.edit_schema.add_page_property_form_data,
                        ...action.payload,
                    }
                }
            }
        }
        case ACTIONS.ADD_PAGE_PROPERTY: {
            const add_page_property_form_data = get(state, ['edit_schema', 'add_page_property_form_data']);
            let schema = get(state, ['edit_schema', 'schema'], {});

            const page_id = get(state, ['edit_schema', 'page_schema', 'id']);
            if (page_id === undefined) {
                return state;
            }

            const type_index = get(add_page_property_form_data, ['type'], 0);

            const addFn = get(generate_map, [type_index, 'addFn']);
            if (addFn === undefined) {
                return state;
            }

            schema = addFn(add_page_property_form_data, schema, page_id);
            const page_schema = get(schema, ['properties', page_id]);
            return {
                ...state,
                edit_schema: {
                    ...state.edit_schema,
                    has_edited: true,
                    has_saved: false,
                    schema,
                    add_page_property_form_data: {},
                    show_add_page_property: false,
                    page_schema,
                }
            }
        }
        case ACTIONS.CREATE_SCHEMA_SUCCESS: {
            // check if ID is as expected otherwise update the ID
            const recently_added = state.schema_list[state.schema_list.length-1].id;
            if (recently_added !== action.payload) {
                return {
                    ...state,
                    schema_list: state.schema_list.map((schema_obj) => {
                        if (recently_added === schema_obj.id) {
                            return { ...schema_obj, id: action.payload };
                        }
                        return schema_obj;
                    }),
                }
            }
            return state;
        }
        case ACTIONS.CREATE_SCHEMA_FAIL: {
            return {
                ...state,
                admin_error: 'Failed to create a new schema on server!',
            };
        }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/Admin/reducer.js